import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import Location from 'services/Location';

declare const window: {
  dataLayer: any[];
};

class GTM {
  init(): void {
    if (!Location.isTrackingRouteBlocked()) {
      Analytics({
        app: 'accounts.livechatinc.com',
        plugins: [
          googleTagManager({
            containerId: `GTM-${import.meta.env.VITE_APP_GTM}`,
          }),
        ],
      });
    }
  }

  async track(event, opts = {}): Promise<any> {
    return new Promise((resolve): void => {
      const e = { ...opts, event, eventCallback: resolve };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(e);
    });
  }
}

export default new GTM();
